<script>
  // Перенос BuyBtn из pass.tsx.
  import { t } from '../../i18n.js';
  import GoldBtn from './goldbtn.svelte';
  import GhostBtn from './ghostbtn.svelte';
  import Jc from './jc.svelte';
  export let price = 0;
  export let balance = 0;
  export let onBuy = () => {};
</script>

{#if balance < price}
  <GhostBtn block size="sm" disabled style="opacity:0.45;cursor:default">{t('m.notEnough')}</GhostBtn>
{:else}
  <GoldBtn block size="sm" on:click={onBuy}>{t('m.buy')} · <Jc v={price} /></GoldBtn>
{/if}
